module.exports = __webpack_public_path__ + "static/media/wechat-bind-bg.d22e81e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wechat/wechat-bind-bg.png
// module id = 792
// module chunks = 114